import React  from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import ReduxPromise from 'redux-promise';

import { addReducerSet } from 'meld-clients-core/lib/reducers';
import graphReducer from './reducers/graph';
import App from './containers/app';

var NYPReducers = addReducerSet('NYPGraph', graphReducer);
//const createStoreWithMiddleware = applyMiddleware(thunk, ReduxPromise)(createStore);

//	<Provider store={createStoreWithMiddleware(lohengrinReducers)}>
ReactDOM.render(
	<Provider store={createStore(NYPReducers, applyMiddleware(thunk, ReduxPromise))}>
		<App />
	</Provider>
	, document.querySelector('.container'));
